import 'imagesloaded';
import 'isotope-layout/dist/isotope.pkgd.min.js';
import 'jquery-match-height/dist/jquery.matchHeight';

/* eslint-disable */

function getSearchParameters() {
  var prmstr = window.location.search.substr(1);
  return prmstr != null && prmstr != '' ? transformToAssocArray(prmstr) : {};
}

function transformToAssocArray(prmstr) {
  var params = {};
  var prmarr = prmstr.split('&');
  for (var i = 0; i < prmarr.length; i++) {
    var tmparr = prmarr[i].split('=');
    params[tmparr[0]] = tmparr[1];
  }
  return params;
}

var params = getSearchParameters();

var filter = {
  category: params.category || '*',
  level: params.level || '*',
  kueche: params.kueche || '*',
}



export default {
  init() {

    // if there's search parameters, change the filter immediately

    //equal Height
    if ($(window).width() > 567) {
      $('.isotope-posts h3').matchHeight();
    } else {
      $('.isotope-posts h3').matchHeight({ remove: true });
    }

    //==================
    //= create the isotope
    var $isotope = $('.isotope-posts').imagesLoaded( () => {
      $isotope.isotope({
        itemSelector: '.isotope-item',
        percentPosition: true,
        layoutMode: 'fitRows',
        filter: function() {
          var $this = $(this).children('article');
          var categories = $this.attr('wmtm-categories') || '';
          var ebene = $this.attr('wmtm-ebene') || '';
          var kueche = $this.attr('wmtm-kueche') || '';
          var categoryResult = filter.category == '*' ? true : categories.match(filter.category);
          var ebeneResult = filter.level == '*' ? true : ebene.match(filter.level);
          var kuecheResult = filter.kueche == '*' ? true : kueche.match(filter.kueche);

          return categoryResult && ebeneResult && kuecheResult;
        },
      });
    });

    //=================
    //= UI (Filterbuttons n stuff)

    $('.filter-button').click((e) => {
      var $btn = $(e.currentTarget);
      $btn.siblings().attr('wmtm-filter-active', null);
      $btn.attr('wmtm-filter-active', (_, attr) =>  attr=='' ? null : '' );
      var cat_filter = $btn.attr('wmtm-category-filter'),
        levels_filter = $btn.attr('wmtm-ebene-filter'),
        kueche_filter = $btn.attr('wmtm-kueche-filter');

      console.log(cat_filter);
      if(typeof(cat_filter) !== 'undefined') {
        filter.category = (cat_filter != filter.category ? cat_filter : '*');
      }

      if(typeof(levels_filter) !== 'undefined') {
        filter.level = (levels_filter != filter.level ? levels_filter : '*');
      }

      if(typeof(kueche_filter) !== 'undefined') {
        filter.kueche = (kueche_filter != filter.kueche ? kueche_filter : '*');
      }

      $isotope.isotope('arrange');
    });

    // Isotope bei Resize Window
    $(window).resize(function () {

      if ($(window).width() >= 567) {
        $('.isotope-posts h3').matchHeight({ byRow: false });
      } else {
        $('.isotope-posts h3').matchHeight({ remove: true });
      }
      $isotope.isotope('layout');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/htheme/pagebuilder/components/isotope.js